var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-navigation-page',{attrs:{"title":"Settings","items":_vm.navItems},on:{"nav-item-selected":_vm.onNavItemSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }